import { cn } from '@/lib/utils'
import { useStudioLocale } from '@/i18n'

interface TierFilterPillsProps {
  selected: 'all' | 'A' | 'B'
  onChange: (tier: 'all' | 'A' | 'B') => void
}

/** The pill ORDER. `A` and `B` are grades, not words, and stay Latin in every
 *  language; the word `Tier` in front of them does not. */
const PILL_VALUES: Array<'all' | 'A' | 'B'> = ['all', 'A', 'B']

export function TierFilterPills({ selected, onChange }: TierFilterPillsProps) {
  const copy = useStudioLocale().strings.starters.gallery
  return (
    <div className="flex items-center gap-2">
      {PILL_VALUES.map((value) => (
        <button
          key={value}
          onClick={() => onChange(value === selected ? 'all' : value)}
          className={cn(
            'inline-flex min-h-10 items-center rounded-full px-4 text-xs font-medium whitespace-nowrap transition-colors',
            value === selected
              ? 'bg-foreground text-background'
              : 'bg-muted text-muted-foreground hover:text-foreground',
          )}
        >
          {value === 'all' ? copy.all : copy.tier(value)}
        </button>
      ))}
    </div>
  )
}
